export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./games-general-settings.vue?vue&type=template&id=b119d74c"


//////////////////
// WEBPACK FOOTER
// ./src/components/common/games-general-settings.vue?vue&type=template&id=b119d74c
// module id = gz9V
// module chunks = 0